
export default function BiographySection() {
  return (
    <section className="py-20 bg-dark-800">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Headshot - Different styling than home page */}
          <div className="order-2 lg:order-1">
            <div className="relative max-w-md mx-auto">
              <div className="w-full h-80 rounded-3xl shadow-2xl overflow-hidden border border-dark-700">
                <img 
                  src="https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/54d5be67d9842835a1a500aee6ea8ce2.jfif"
                  alt="Professional Headshot"
                  className="w-full h-full object-cover"
                  style={{ objectPosition: '50% 44%' }}
                />
              </div>
              {/* Professional badges overlay */}
              <div className="absolute -bottom-4 -right-4 bg-red-700 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                25+ Years
              </div>
              <div className="absolute -top-4 -left-4 bg-dark-800 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg border border-dark-600">
                Level 2
              </div>
            </div>
          </div>
          
          {/* Biography Content */}
          <div className="order-1 lg:order-2 space-y-8">
            <div>
              <div className="text-red-500 font-semibold text-lg mb-2">Tony Monteiro • Licensed Mortgage Agent • Lic# 13121</div>
              <h1 className="text-4xl lg:text-5xl font-bold text-white mb-6">
                25+ Years of Mortgage Excellence
              </h1>
              <p className="text-xl text-gray-300 leading-relaxed">
                As a Level 2 Certified Mortgage Professional with over two decades of experience, 
                I've dedicated my career to helping Ontario families navigate the complex world of mortgage financing.
              </p>
            </div>
            
            <div className="space-y-6">
              <div className="bg-dark-800 border border-dark-700 rounded-xl p-6">
                <h3 className="font-bold text-lg text-white mb-3 flex items-center">
                  <i className="ri-trophy-line text-red-500 mr-2"></i>
                  Professional Expertise
                </h3>
                <p className="text-gray-300">
                  My Level 2 Certification represents the highest standard of mortgage industry knowledge, 
                  ensuring you receive expert guidance on even the most complex financing scenarios.
                </p>
              </div>
              
              <div className="bg-dark-800 border border-dark-700 rounded-xl p-6">
                <h3 className="font-bold text-lg text-white mb-3 flex items-center">
                  <i className="ri-heart-line text-red-500 mr-2"></i>
                  Client-First Philosophy
                </h3>
                <p className="text-gray-300">
                  Every client deserves personalized attention and solutions tailored to their unique situation. 
                  Whether you're refinancing, consolidating debt, or leveraging home equity, I'm here to guide you.
                </p>
              </div>
              
              <div className="bg-dark-800 border border-dark-700 rounded-xl p-6">
                <h3 className="font-bold text-lg text-white mb-3 flex items-center">
                  <i className="ri-key-line text-red-500 mr-2"></i>
                  Private Lending Specialist
                </h3>
                <p className="text-gray-300">
                  When traditional lenders say no, I find solutions. My extensive network includes private lending 
                  options for challenging cases that require creative financing approaches.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
